import { VRMPose } from '@pixiv/three-vrm';

export function loadPoseJson(url: string | undefined): Promise<VRMPose | null> {
  if (!url) return Promise.resolve(null);
  return fetch(url).then(resp => resp.json());
}
